import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';

const ImportShapefilesHeader = (props): JSX.Element => {
  const {
    stage,
    handleModal,
    onSubmitToSecondStage,
    onSubmitToThirdStage,
    onSubmitToFinish,
    handleStateField,
  } = props;

  const renderButtonText = (): string => {
    let text = '';
    switch (stage) {
      case 1:
        text = 'Visualizar prévia';
        break;
      case 2:
        text = 'Continuar';
        break;
      case 3:
        text = 'Concluir importação';
        break;
      default:
        break;
    }
    return text;
  };

  const onSubmitToNextStage = (): void => {
    switch (stage) {
      case 1:
        onSubmitToSecondStage();
        break;
      case 2:
        onSubmitToThirdStage();
        break;
      case 3:
        onSubmitToFinish();
        break;
      default:
        break;
    }
  };

  return (
    <Row gutter={24} className="row-header">
      <Col xs={{ span: 24 }} md={{ span: 14 }}>
        <span className="service-title">
          {stage === 3 ? 'Informações dos talhões' : 'Importar Talhões'}
        </span>
      </Col>
      <Col xs={{ span: 24 }} md={{ span: 10 }} className="button-col">
        {stage === 3 && (
          <Button
            type="primary"
            className="button-grey"
            onClick={
              (): void => {
                handleStateField('stage', 2);
                handleStateField('zoom', 16);
              }
            }
          >
            Voltar
          </Button>
        )}
        <Button
          type="primary"
          className={stage === 3 ? 'button-red' : 'button-grey'}
          onClick={
            (): void => {
              handleModal('cancel');
            }
          }
        >
          Cancelar
        </Button>
        <Button
          type="primary"
          className="button-save"
          onClick={
            (): void => {
              onSubmitToNextStage();
            }
          }
        >
          {renderButtonText()}
        </Button>
      </Col>
    </Row>
  );
};

ImportShapefilesHeader.propTypes = {
  stage: PropTypes.number.isRequired,
  handleModal: PropTypes.func.isRequired,
  onSubmitToSecondStage: PropTypes.func.isRequired,
  onSubmitToThirdStage: PropTypes.func.isRequired,
  onSubmitToFinish: PropTypes.func.isRequired,
  handleStateField: PropTypes.func.isRequired,
};

ImportShapefilesHeader.defaultProps = {};

export default ImportShapefilesHeader;
